import React, { useCallback, useEffect, useState, useRef, useLayoutEffect } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Spinner from 'react-bootstrap/Spinner';
import Popover from 'react-bootstrap/Popover';
import Overlay from 'react-bootstrap/Overlay';
import Modal from 'react-bootstrap/Modal';
import { useToasts } from 'react-toast-notifications';
import { useDropzone } from 'react-dropzone';
import axios from 'axios';
import Croppie from 'croppie';
import { s3Link } from '../utils/constants';
import { isMobile } from 'react-device-detect';
import { setAlert, setUser } from '../../redux/actions.js';
import "croppie/croppie.css";
import CloseButton from './CloseButton';
import { connect } from 'react-redux';
import { useDispatch } from 'react-redux';

const MAX_CROPPIE_WIDTH = 850;
const MAX_CROPPIE_HEIGHT = 435;

const ProfileCoverUploader = ({
    user,
    getUserInformation,
    profileBkg = false,
    userInformation,
    userFetching,

    isDarkmode
}) => {
    const dispatch = useDispatch();
    const [croppie, setCroppie] = useState('');

    const [isCoverLoading, setIsCoverLoading] = useState(false);
    const [cover, setCover] = useState('');
    const [coverObj, setCoverObj] = useState('');
    const [error, setError] = useState('');
    const [showError, setShowError] = useState(false);
    const [isDefaultCoverPic, setIsDefaultCoverPic] = useState(true);
    const [show, setShow] = useState(false);

    useEffect(() => {
        const handleResize = () => {
            calculateWidth();
        };

        window.addEventListener('resize', handleResize);

        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);

    const handleClose = () => setShow(false);
    const handleShow = () => {
        setShow(true);
        setCroppie("");
    };

    const onDropRejected = useCallback(() => {
        setError('Only .jpg, .jpeg, .png files are accepted');
    }, []);

    const onDropAccepted = useCallback((acceptedFiles) => {
        setCover(acceptedFiles[0]);
        setCoverObj(URL.createObjectURL(acceptedFiles[0]));
        upload(acceptedFiles[0]);
    }, []);

    useEffect(() => {
        setShowError(true);
    }, [showError]);

    const {
        getRootProps,
        getInputProps,
        isDragActive,
    } = useDropzone({
        onDropRejected,
        onDropAccepted,
        accept: 'image/jpeg, image/png',
        maxFiles: 1,
        multiple: false,
    });

    const upload = async (payload, type = '') => {
        setIsCoverLoading(true);
        const formData = new FormData();
        formData.append('cover_pic', payload);
        formData.append('cover_pic_type', type);
        formData.append('cover_pic_orientation', 'portrait');
        await axios.post(
            `/api/users/${localStorage.getItem('loggedin_user')}`,
            formData,
            {
                headers: {
                    'Content-Type': 'multipart/form-data',
                },
            },
        )
            .then((response) => {
                getUserInformation();
                dispatch(setAlert({
                    show: true,
                    type: 'success',
                    body: 'Photo successfully updated'
                }));
            })
            .catch((error) => {
                console.log({ error });
                dispatch(setAlert({
                    show: true,
                    type: 'error',
                    body: 'Unable to update cover photo'
                }));
            })
            .finally(() => {
                // checkCoverPic()
                setIsCoverLoading(false);
            });
    };

    const handleCroppie = (image) => {
        var el = document.getElementById("image-helper");
        var viewportWidth = window.innerWidth > MAX_CROPPIE_WIDTH ? 900 : 400;
        if (el) {
            if (viewportWidth === 900) {
                var croppieInstance = new Croppie(el, {
                    enableExif: true,
                    boundary: { // gray background behind image
                        width: profileBkg ? (viewportWidth / 2) : viewportWidth,
                        height: profileBkg ? viewportWidth / 2 : viewportWidth / 2,
                    },
                    viewport: {
                        width: profileBkg ? MAX_CROPPIE_HEIGHT / 2 : MAX_CROPPIE_WIDTH,
                        height: profileBkg ? MAX_CROPPIE_WIDTH / 2 : MAX_CROPPIE_HEIGHT,
                        type: 'square'
                    },
                    enableOrientation: true
                });
            } else {
                const actualWidth = window.innerWidth - (30 + 16); // 15px * 2  padding of modal + 16 modal margin at .5rem * 2
                var croppieInstance = new Croppie(el, {
                    enableExif: true,
                    boundary: {
                        width: profileBkg ? ((actualWidth / 2) + 100) : actualWidth,
                        height: profileBkg ? actualWidth : (actualWidth / 2) + 100,
                    },
                    viewport: {
                        width: profileBkg ? actualWidth / 2 : actualWidth,
                        height: profileBkg ? actualWidth : actualWidth / 2,
                        type: 'square'
                    },
                    enableOrientation: true
                });
            }

            croppieInstance.bind({
                url: image,
                orientation: 1,
            });

            setCroppie(croppieInstance);
        }
    };

    const [popShow, setPopShow] = useState(false);
    const [target, setTarget] = useState(null);
    const ref = useRef(null);

    const handlePopShow = (event) => {
        setPopShow(!popShow);
        setTarget(event.target);
    };

    const uploadChange = (event) => {
        const type = event.target.files[0].type;

        // upload(event.target.files[0], 'original') // upload on add of image

        if (type.indexOf('image') < 0) {
            setError('Only .jpg, .jpeg, .png files are accepted');
            return;
        }
        setError('');
        handleCroppie(URL.createObjectURL(event.target.files[0]));
    };

    const handleCropUpload = () => {
        croppie.result({
            type: 'blob',
            size: {
                width: profileBkg ? MAX_CROPPIE_HEIGHT : MAX_CROPPIE_WIDTH,
                height: profileBkg ? MAX_CROPPIE_WIDTH : MAX_CROPPIE_HEIGHT
            },
            format: 'jpeg',
            quality: 1
        }).then(function (blob) {
            setCoverObj(URL.createObjectURL(blob));
            upload(blob);
        });
    };

    const handleRemovePorfilePic = async () => {
        setIsCoverLoading(true);
        await axios.post(`/api/users/${localStorage.getItem('loggedin_user')}`, {
            action: 'remove_cover_picture'
        })
            .then((response) => {
                setCoverPic('');
                setCoverObj('');
                getUserInformation();
                setIsDefaultCoverPic(true);
                dispatch(setAlert({
                    show: true,
                    type: 'success',
                    body: 'Photo successfully updated'
                }));
            }).catch(error => {
                console.log({ error });
                dispatch(setAlert({
                    show: true,
                    type: 'error',
                    body: 'Unable to process request'
                }));
            }).finally(() => {
                setIsCoverLoading(false);
            });
    };

    const [coverPic, setCoverPic] = useState('');
    const [isCheckingAvatar, setIsCheckingAvatar] = useState(false);
    const updateCoverBackground = () => {
        if (userInformation && Object.keys(userInformation).length > 0) {
            let image = '';
            if (profileBkg) {
                image = `${s3Link}/${userInformation.id}/back_port.jpg?t=${new Date().valueOf()}`;
            } else {
                image = `${s3Link}/${userInformation.id}/cover_photo.jpg?t=${new Date().valueOf()}`;
            }
            setCoverPic(image);
        }

        setIsDefaultCoverPic(!user.cover_pic);
    };

    useEffect(() => {
        let isMounted = true;
        updateCoverBackground();

        return () => { isMounted = false; };
    }, [profileBkg, userInformation]);

    useLayoutEffect(() => {
        calculateWidth();

        updateCoverBackground();
    }, [profileBkg]);

    const calculateWidth = () => {
        const containerWidth = $('.cover-box').width();
        if (containerWidth > MAX_CROPPIE_WIDTH) {
            if (profileBkg) {
                $('.changeCoverPlaceholder').width(210);
                $('.changeCoverPlaceholder').height(460);
            } else {
                $('.changeCoverPlaceholder').width(MAX_CROPPIE_HEIGHT);
                $('.changeCoverPlaceholder').height(MAX_CROPPIE_WIDTH);
            }
        } else {
            if (profileBkg) {
                $('.changeCoverPlaceholder').width(210);
                $('.changeCoverPlaceholder').height(460);
            } else {
                $('.changeCoverPlaceholder').width('100%');
                $('.changeCoverPlaceholder').height(parseInt(parseInt(containerWidth) / 2));
            }
        }
    };

    return (
        <>
            <Modal className="prof-uploader profcover-uploader text-center" show={show} onHide={handleClose} centered>
                <Modal.Header>
                    <CloseButton
                        onClick={handleClose}
                        style={{
                            position: 'absolute',
                            top: '24px',
                            right: '12px'
                        }}
                    />
                    <Modal.Title><b>Position and size your photo</b></Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div id="image-helper"></div>
                    {croppie === "" && <div>
                        <span className="icon">
                            <FontAwesomeIcon icon={['far', 'image']} />
                        </span>
                        <span className="str">
                            Upload photo here
                        </span>
                        <div className="upload">
                            <input id="prof-upload" onChange={uploadChange} type="file" accept="image/jpeg, image/png" />
                            <button className="btn theme-btn theme-btn-bordered">Upload</button>
                        </div>

                        {error && <div className="mt-3 text-danger">{error}</div>}
                    </div>}
                    {croppie !== "" &&
                        <div className="prof-uploader-btns">
                            <div className="prof-uploader-btns-wrapper">
                                <button onClick={handleClose} className="btn theme-btn theme-btn-white theme-btn-bordered">Cancel</button>
                                <button onClick={() => { handleCropUpload(); handleClose(); }} className="btn theme-btn theme-btn-bordered">Save</button>
                            </div>
                        </div>
                    }
                </Modal.Body>
            </Modal>
            <Overlay show={popShow} target={target} placement="bottom" container={ref.current}
                containerPadding={20}>
                <Popover id="popover-basic" className="prof-overlay">
                    <Popover.Content>
                        <ul onClick={handlePopShow}>
                            <li onClick={handleShow}><a>{isDefaultCoverPic ? 'Upload photo' : 'Change photo'}</a></li>
                            {!isDefaultCoverPic &&
                                <li onClick={handleRemovePorfilePic}><a>Remove photo</a></li>
                            }
                            <li><a>Cancel</a></li>
                        </ul>
                    </Popover.Content>
                </Popover>
            </Overlay>
            {profileBkg && <h5 className="mt-2 mb-0">Mobile</h5>}
            <div
                style={
                    cover || !isCheckingAvatar ? {
                        backgroundImage: `url(${coverObj || coverPic})`,
                        backgroundRepeat: 'no-repeat',
                        backgroundPosition: 'center center',
                        backgroundColor: `${coverObj || coverPic
                            ? (
                                isDarkmode ? '#5f5f5f' : '#fcfcfc'
                            )
                            : 'rgba(0,0,0,.5)'}`,
                        backgroundSize: '210px 460px !important'
                    } : {}
                }
                className={`changeCoverPlaceholder${profileBkg ? ' bg-portrait' : ''}`}
                {...getRootProps()} onClick={handlePopShow}
            >
                <div className="changeCoverPlaceholder-wrapper">
                    {
                        isCoverLoading ? (
                            <Spinner animation="border" role="status" size="sm" variant="primary">
                                <span className="sr-only">Uploading...</span>
                            </Spinner>
                        )
                            : (
                                <>
                                    <FontAwesomeIcon icon={['fas', 'image']} />
                                    {
                                        isDragActive
                                            ? <p>Drop the files here ...</p>
                                            : <p>Change your photo</p>
                                    }
                                </>
                            )
                    }
                </div>
            </div>
        </>
    );
};

const mapStateToProps = state => {
    return {
        userInformation: state.user.user,
        userFetching: state.user.isFetching,
        isDarkmode: state.privaGlobal.darkmode
    };
};

export default connect(mapStateToProps)(ProfileCoverUploader);
